import { TweenMax, TimelineMax, Quint } from 'gsap';

const getBounds = (ratio, reference, inside, max) => {
    var bounds = {x:0, y:0, width:reference.width, height:reference.height};

    max = Object.assign({
        top:0,
        left:0,
        bottom:1,
        right:1
    }, max);

    var maxRatio = ((max.right - max.left)*reference.width) / ((max.bottom - max.top)*reference.height) | 0;
    var refRatio  = reference.width/reference.height;


    // Scale the image
    if (inside ? (refRatio >= ratio) : (refRatio < ratio)) {
        bounds.width  = reference.height * ratio;
        bounds.x      = (reference.width - bounds.width)/2 | 0;

    }
    else{
        bounds.height = reference.width / ratio;
        bounds.y      = (reference.height - bounds.height)/2 | 0;
    }

    if(!inside){
        var dx  = max.right * bounds.width - max.left * bounds.width;
        if(dx < reference.width && dx > 0){
            bounds.width *= reference.width / dx;
            bounds.height = bounds.width / ratio;
        }

        var dy = max.bottom * bounds.height - max.top * bounds.height;
        if(dy < reference.height && dy > 0){
            bounds.height *= reference.height / dy;
            bounds.width  = bounds.height * ratio;
        }

        bounds.width  = Math.ceil(bounds.width);
        bounds.height = Math.ceil(bounds.height);

        bounds.x      = -max.left * bounds.width - ((max.right - max.left) * bounds.width - reference.width)/2 | 0;
        bounds.y      = -max.top * bounds.height - ((max.bottom - max.top) * bounds.height - reference.height)/2 | 0;
    }


    return bounds;
}

const getDataTransform = (options, bounds, item) => {
    var data = {};
    data["force3D"] = true;
    if(bounds.width && !options.heightOnly){
        if(!options.sizeOnly && !options.widthOnly)
            data["x"] = bounds.x;
        data["scaleX"] = bounds.width / item.offsetWidth;
    }
    if(bounds.height && !options.widthOnly){
        if(!options.sizeOnly && !options.heightOnly)
            data["y"] = bounds.y;
        data["scaleY"] = bounds.height / item.offsetHeight ;
    }
    return data;
};

const getData = (options, bounds) => {
    var data = {};
    if(bounds.width && !options.heightOnly){
        if(!options.sizeOnly && !options.widthOnly)
            data["left"] = bounds.x;
        data["width"] = bounds.width;
    }
    if(bounds.height && !options.widthOnly){
        if(!options.sizeOnly && !options.heightOnly)
            data["top"] = bounds.y;
        data["height"] = bounds.height;
    }
    return data;
};

const Fit = (elements, options) => {
    if(typeof elements == 'string')
        elements = document.querySelectorAll(elements);
    elements = (elements && typeof elements[Symbol.iterator] === 'function') ? Array.from(elements) : [elements];


    options = Object.assign({
        inside:typeof options == "boolean"?options:false,
        animate:false,
        duration:1,
        ease:Quint.easeInOut,
        reference:null,
        ratio:null,
        useTransform:false,
        sizeOnly:false,
        heightOnly:false,
        widthOnly:false
    }, options);

    var t = new TimelineMax({paused:true});

    elements.forEach(item => {
        let reference = options.reference ? options.reference : item.parentElement;
        let data = item.dataset;


        var ratio = options.ratio;
        var width = 0;

        var height = 0;
        var tagName         = item.tagName.toLowerCase();

        if(reference.tagName && reference.tagName.toLowerCase() == "picture"){
            var picture = reference;
            reference = reference.parentElement;

            //Find correct data from sources
            Array.from(picture.querySelectorAll('source')).forEach(source => {
                var mql = window.matchMedia(source.getAttribute('media'));
                if(mql.matches){
                    data = Object.assign({}, data, source.dataset);
                }
            });
        }

        if(!ratio){
            if(data.ratio)
                ratio = data.ratio;
            else if(data.width && data.height){
                width = data.width;
                height = data.height;
                ratio = width / height;
            }
            else if(tagName == "video"){
                width  = item.videoWidth;
                height = item.videoHeight;
                ratio = width / height;
            }
            else if(tagName == "picture"){
                let img = item.querySelector('img');
                    img.style.width = '100%';
                    img.style.height = '100%';
                //If it's an image, check whether it's loaded or not
                if(img.complete){
                    width = item.attr('width');
                    height = item.attr('height')
                    if(!width)  width  = item.naturalWidth;
                    if(!height) height = item.naturalHeight;
                    ratio = width / height;
                }
                else{
                    img.addEventListener('load', () => Fit(item, options));
                    return;
                }
            }
            else{
                //If it's an image, check whether it's loaded or not
                if(item.complete){
                    width   = item.getAttribute('width');
                    height  = item.getAttribute('height')
                    if(!width)  width  = item.naturalWidth;
                    if(!height) height = item.naturalHeight;
                    ratio = width / height;
                }
                else{
                    item.addEventListener('load', () => Fit(item, options));
                    return;
                }
            }
        }


        var refBounds = reference.tagName? {x:0, y:0, width:reference.offsetWidth, height:reference.offsetHeight }:options.reference;

        var max = {
            top:data.maxTop | 0,
            left:data.maxLeft | 0,
            bottom:data.maxBottom | 1,
            right:data.maxRight | 1
        };

        if(options.hasOwnProperty('maxTop'))
            max.top = options.maxTop;
        if(options.hasOwnProperty('maxLeft'))
            max.left = options.maxLeft;
        if(options.hasOwnProperty('maxRight'))
            max.right = options.maxRight;
        if(options.hasOwnProperty('maxBottom'))
            max.bottom = options.maxBottom;

        var bounds = getBounds(ratio, refBounds, options.inside, max);
        var tween = {};

        if(options.useTransform){
            tween = getDataTransform(options, bounds, item);
        }
        else{
            tween = getData(options, bounds);
        }
        if(options.animate){
            tween["ease"] = options.ease;
            t.to(item, options.duration, tween, 0);
        }
        else TweenMax.set(item, tween, 0);
    });

    return t.play();
}

Fit.getBounds = getBounds;

export { Fit, Fit as fit };